import { create } from 'zustand';
import Alertas from '../alerts/AlertasGernericos';
import CryptoJS from 'crypto-js';


export const useCryptoStore = create((set, get) => ({

    token_descripto: null,

    Cripto: async (token) => {
        try {
            let key = process.env.REACT_APP_CRYPTO;

            const dadosCriptografados = CryptoJS.AES.encrypt(
                JSON.stringify(token),
                key
            ).toString();

            if (!dadosCriptografados || dadosCriptografados === "") {
                return 'error';
            }

            localStorage.setItem('tk', dadosCriptografados)

        } catch (err) {
            Alertas.ExibirAlertaErro(err.message || "Erro desconhecido durante o login.");
        }
    },

    Descripto: async () => {
        try {
            let key = process.env.REACT_APP_CRYPTO;

            let token_criptografado = await localStorage.getItem('tk');


            if (!token_criptografado || token_criptografado === '') {
                return;
            }

            const bytes = CryptoJS.AES.decrypt(token_criptografado, key);
            const dadosOriginais = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

            if (!dadosOriginais || dadosOriginais === "") {
                return;
            }

            return dadosOriginais;

        } catch (err) {
            Alertas.ExibirAlertaErro(err.message || "Erro desconhecido durante o login.");
        }
    },
}));



